import React,{useEffect,useState} from 'react'
import './DataTable.css'
import Axios from 'axios'
import {Card,CardContent} from '@material-ui/core'
import Table from './Table'


function DataTable() {
    const [pollData,setPollData]=useState([]);
    useEffect(()=>{
        const getData=async ()=>{
            await fetch('https://onevotematters.herokuapp.com/data')
                .then((responce)=>responce.json())
                .then((data)=>{
                    setPollData(data.data);
                })
        };
        
        getData();

    },[]);
    console.log(pollData);


    return (
        <>
            <Card className="app_center">
                <CardContent color="textSecondary">
                    <h2>Data of person casted the votes</h2>
                    <Table pollData={pollData}/>
                </CardContent>

            </Card>
        </>
    )
}

export default DataTable
